import React from 'react'

export default function renderNode({ typeOfContent, data }) {
  const textBlock = data.map((sentence, innerIndex) => {
    const j = innerIndex
    let wrapperString
    if (sentence.nodeType === 'text') {
      wrapperString = `${sentence.value}`
      sentence.marks.forEach(mark => {
        if (mark.type === 'bold') {
          wrapperString = `<strong>${wrapperString}</strong>`
        } else if (mark.type === 'italic') {
          wrapperString = `<i>${wrapperString}</i>`
        } else if (mark.type === 'underline') {
          wrapperString = `<u>${wrapperString}</u>`
        }
      })
    }
    if (sentence.nodeType === 'hyperlink') {
      const link = `${sentence.data.uri}`
      sentence.content.forEach(text => {
        const linkName = `${text.value}`
        wrapperString = `<a href='${link}' class=${
          typeOfContent === 'legal' ? 'legal__link' : ''
        }>${linkName}</a>`
      })
    }

    return (Object.prototype.hasOwnProperty.call(sentence, 'marks') &&
      sentence.marks.length !== 0) ||
      sentence.data.uri ? (
      /* eslint-disable react/no-danger */
      <span key={j} dangerouslySetInnerHTML={{ __html: wrapperString }} />
    ) : (
      wrapperString
    )
  })
  return textBlock
}
